// extracted by mini-css-extract-plugin
export default {"capabilitiesSection":"Qa5yeVUyZy7FTWy82Lg5","heading":"zntgvOyea0RzVh1JYlhL","cards":"BwDNHFZuUdM8my9El2Ie"};